import styled from "styled-components";
import { baseColors } from "../../../../../../../../themes/definitions/si/cis/base-colors";
import { HistoryRecordDateValueDefaultBox } from "./history-record-date-value.default.box";

export const HistoryRecordDateValueSiCisBox = styled(HistoryRecordDateValueDefaultBox)`
    color: ${baseColors.base08};
`;